import React from 'react';
import pb from '../../../assets/participants-black.svg';
import setup from '../../../assets/setup-img.png';
import arrowLeft from '../../../assets/arrow-left-long.svg';
import { Link } from 'react-router-dom';
import arrowRight from '../../../assets/arrow_right_new.png';
import dr15_2 from "../../../assets/dr15_2.png";

const StepTwoContent = ({
  prevStep,
  nextStep,
  setAcceptTerms,
  headerProgress,
  enableFullScreen,
  getUserLocation,
  assessmentId,
  step,
  acceptTerms
}: any) => {
  React.useEffect(() => {
    getUserLocation();
  }, []);
  const styles = {
    bottomBg: {
      position: "fixed" as const,
      top: "10%",
      left: 0,
      bottom: 0,
      width: "100%",
      height: "auto",
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "bottom center",
      backgroundImage: `url(${dr15_2})`,
      zIndex: -4,
    }
  }
  return (
    <section className="dasboard-content lg:w-[calc(100%-15rem)] bg-gray-sm min-h-[calc(100vh-104px)] sm:px-3 px-1 sm:py-1 py-4 flex flex-col mb-[5rem]">
      {headerProgress > 0 && (
        <div className="w-full bg-gray-200 h-2 dark:bg-gray-700">
          <div
            className="bg-amber-300 h-2"
            style={{ width: `${headerProgress}%` }}
          />
        </div>
      )}
      <div className="mx-auto max-w-7xl px-4 flex flex-col flex-grow">
        <div className="w-full flex justify-start items-start mt-4 pb-6 mb-5">
          <div className="flex flex-col gap-2 w-full">
            <span className="font-bold text-[24px] text-[#141414]" style={{ fontFamily: '"Inter", sans-serif' }}>
              Hello, User! 👋
            </span>
            <span className="font-medium text-[12px] text-[#989ca0]" style={{ fontFamily: '"Inter", sans-serif' }}>
              Welcome back, track your team progress here!
            </span>
          </div>
        </div>
        {/* Instructions Header */}
        <div className="flex-grow">

          <h3 className="md:text-3xl sm:text-2xl text-xl md:mb-6 sm:mb-4 mb-2 font-medium" style={{ fontFamily: '"Inter", sans-serif' }}>Instructions</h3>

          <div className="flex flex-wrap justify-between">
            <div className="md:w-8/12 w-full">
              <p className="text-red-600" style={{ fontFamily: '"Inter", sans-serif' }}>*Scroll down to accept Terms & Conditions</p>
              <p className="text-red-600" style={{ fontFamily: '"Inter", sans-serif' }}><strong>Important NOTE:</strong></p>
              <strong style={{ fontFamily: '"Inter", sans-serif' }}>BY CONTINUING TO TEST YOU WILL BE SHIFTED TO FULL SCREEN MODE. PLEASE DON'T EXIT THE FULL SCREEN AS IT WILL CANCEL YOUR ASSESSMENT.</strong>

              {/* Instructions List */}
              <div className="mt-4 leading-relaxed">
                <p style={{ fontFamily: '"Inter", sans-serif' }}><strong>1. Read each question carefully:</strong> Take your time to read each question thoroughly and understand what is being asked.</p>
                <p style={{ fontFamily: '"Inter", sans-serif' }}><strong>2. Analyse all choices:</strong> Read all the options before selecting an answer.</p>
                <p style={{ fontFamily: '"Inter", sans-serif' }}><strong>3. Eliminate wrong answers:</strong> If unsure, try to eliminate obviously incorrect options.</p>
                <p style={{ fontFamily: '"Inter", sans-serif' }}><strong>4. Manage your time:</strong> Track time and avoid spending too much on one question.</p>
                <p style={{ fontFamily: '"Inter", sans-serif' }}><strong>5. Watch for qualifiers:</strong> Words like "always" or "never" can indicate correct answers.</p>
                <p style={{ fontFamily: '"Inter", sans-serif' }}><strong>6. Be cautious with tricky options:</strong> "All of the above" and "None of the above" require careful evaluation.</p>
                <p style={{ fontFamily: '"Inter", sans-serif' }}><strong>7. Stay confident:</strong> Make an educated guess instead of leaving answers blank.</p>
                <p style={{ fontFamily: '"Inter", sans-serif' }}><strong>8. Review your answers:</strong> Check for careless mistakes if time permits.</p>
                <p style={{ fontFamily: '"Inter", sans-serif' }}><strong>9. Answer every question:</strong> There’s usually no penalty for guessing.</p>
                <p style={{ fontFamily: '"Inter", sans-serif' }}><strong>10. Avoid unfair means:</strong> Cheating will result in assessment cancellation.</p>
                <p style={{ fontFamily: '"Inter", sans-serif' }}><strong>11. Trust your instincts:</strong> If well-prepared, go with your intuition.</p>
              </div>

              {/* Terms & Conditions */}
              <div className="md:pt-6 py-4 border-t-2 border-gray-300">
                <div className="bg-white-100 p-4 md:p-6 rounded-lg flex items-center justify-center gap-20">
                  {/* Terms Text */}
                  <p className="md:text-lg text-sm font-medium text-gray-800" style={{ fontFamily: '"Inter", sans-serif' }}>
                    I ACCEPT THE <span className="text-[#fcd34d] font-bold" style={{ fontFamily: '"Inter", sans-serif' }}>TERMS & CONDITIONS</span>.
                  </p>

                  {/* Styled Checkbox */}
                  <label className="flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      onChange={(e) => setAcceptTerms(e.target.checked)}
                      className="hidden peer"
                    />
                    <div className="w-6 h-6 md:w-8 md:h-8 bg-white border-2 border-gray-400 rounded-lg flex items-center justify-center peer-checked:border-gray-600 peer-checked:bg-[#fcd34d] transition">
                    </div>
                  </label>

                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Buttons Stuck to Bottom Right */}
        <div className="flex justify-end items-center gap-4 mt-auto">
          <Link
            to={`/assessment-overview/${assessmentId}`}
            onClick={prevStep}
            className="sm:py-4 py-2 sm:px-4 px-3 bg-dark-gray rounded-lg inline-flex items-center font-medium sm:text-base text-sm hover:bg-white-800 transition"
            style={{ fontFamily: '"Inter", sans-serif' }}
          >
            <img className="sm:mr-2 mr-1 sm:w-5 w-4" src={arrowLeft} alt="Back" />
            Back
          </Link>

          <button
            className="sm:py-4 py-2 sm:px-4 px-3 bg-blue-600 text-white rounded-lg inline-flex items-center font-medium sm:text-base text-sm hover:bg-blue-700 transition"
            style={{ zIndex: 99999, fontFamily: '"Inter", sans-serif' }}
            onClick={nextStep}
            disabled={step === 1 && !acceptTerms}
          >
            Next
            <img className="sm:ml-2 mr-1 sm:w-5 w-4" src={arrowRight} alt="Next" />
          </button>
        </div>
      </div>
      <div style={styles.bottomBg}></div>

    </section>

  );
};

export default StepTwoContent;
